import { BaseEntity, ChallengeRevision } from "@/types/v2";
import { ConfiguredChallengeMaterial } from "@/types/v2/task/challenge/material.types";
import { TankGroup } from "@/types/v2";
import { Tank } from "@/types/v2";

// Your existing progress entry - keeping this unchanged
export interface ChallengeProgressEntry {
  challenged: number;
  weight: number;
  comment?: string;
  timestamp?: string;
  challengeDuration: number;
  revisions?: Array<ChallengeRevision>;
  administrationEquipment?: string;
}

export interface StandardChallengeConfiguration extends BaseEntity {
  challengeMaterials: ConfiguredChallengeMaterial[];
  challengeDuration?: number | null;
  sourceTank: Tank;
  sourceGroup: TankGroup;
  targetAmount: number;
  targetWeightAmount?: number;
  destinationTank: Tank;
  destinationGroup: TankGroup;
  availableGroups?: TankGroup[];
  selectedGroup?: TankGroup;
  progressData?: Array<ChallengeProgressEntry>;
  instructions?: string;
}

export interface BathChallengeConfiguration extends BaseEntity {
  challengeMaterials: ConfiguredChallengeMaterial[];
  targetAmount: number;
  targetWeightAmount?: number;
  progressData?: Array<ChallengeProgressEntry>;
  instructions?: string;

  challengeDuration: number;
  requiresWeighing: boolean;

  tank?: Tank;              // For simplified bath (single tank)
  sourceTank?: Tank;        // For standard bath with fish handling
  destinationTank?: Tank;   // For standard bath with fish handling
  sourceGroup?: TankGroup;  // For standard bath with fish handling
  destinationGroup?: TankGroup; // For standard bath with fish handling

  isSimplifiedBath: boolean;
  isStandardBath: boolean;

  bathProcess?: {
    startedAt?: string;
    completedAt?: string;
  };
}

export type ChallengeConfiguration = StandardChallengeConfiguration | BathChallengeConfiguration;

export function isStandardChallengeConfiguration(
  config: ChallengeConfiguration
): config is StandardChallengeConfiguration {
  return !('isSimplifiedBath' in config || 'isStandardBath' in config);
}

export function isBathChallengeConfiguration(
  config: ChallengeConfiguration
): config is BathChallengeConfiguration {
  return 'isSimplifiedBath' in config || 'isStandardBath' in config;
}

export function isSimplifiedBath(
  config: ChallengeConfiguration
): config is BathChallengeConfiguration {
  return isBathChallengeConfiguration(config) &&
    config.isSimplifiedBath &&
    !!config.tank;
}

export function isStandardBath(
  config: ChallengeConfiguration
): config is BathChallengeConfiguration {
  return isBathChallengeConfiguration(config) &&
    config.isStandardBath &&
    !!(config.sourceTank && config.destinationTank);
}